import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showUrgency = true,
  showPurchaseNotifications = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-white" data-id="element-0" data-mp="23w4g45bdvc2y">
      <main data-id="element-1" data-mp="23v2rsz5cwt3a">
        <Hero data-id="element-2" data-mp="23t8ea5wf0398" />
        <ProofBar data-id="element-3" data-mp="3ijxo6nd1puib" />
        <Problem data-id="element-4" data-mp="3ikh98cxzsz0k" />
        <WhatYouGet data-id="element-5" data-mp="3iiwfuqnezm4a" />
        <Bonuses data-id="element-6" data-mp="3ijftvw9y1qd1" />
        <Pricing showUrgency={showUrgency} data-id="element-7" data-mp="3ihuyy5jpw5en" />
        <Testimonials data-id="element-8" data-mp="3mkrc3gqhn9b7" />
        <Guarantee data-id="element-9" data-mp="3mjzsz5e2v41t" />
        <Faq data-id="element-10" data-mp="3mjgannkimdn9" />
        <CostOfInaction data-id="element-11" data-mp="3mj6lg27aoaim" />
        <FinalCta showUrgency={showUrgency} data-id="element-12" data-mp="3rbrbcsn2y3gv" />
      </main>
      <Footer data-id="element-13" data-mp="3recd7hndojem" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-14" data-mp="67znpl2q47d" />}
    </div>;
}